var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import * as React from 'react';
import { useStores } from '../../utils/hooks';
import { buildTargetingEvent, hasTargetingChanged, pushTargetingEvent } from './utils';
export var MesoInit = function () {
  var _a = useStores(),
    advertising = _a.advertising,
    detailQuery = _a.detailCriteriaStore.detailQuery,
    searchSummary = _a.activitySearchStore.searchSummary,
    searchCriteriaStore = _a.searchCriteriaStore;
  var _b = __read(React.useState(null), 2),
    currentTargeting = _b[0],
    setCurrentTargeting = _b[1];
  var processTargeting = function () {
    var newTargeting = buildTargetingEvent(advertising, detailQuery, searchSummary, searchCriteriaStore);
    if (hasTargetingChanged(currentTargeting, newTargeting)) {
      setCurrentTargeting(newTargeting);
      // this clear event is currently needed, otherwise, ads are not refreshed, even when search criteria changes.
      pushTargetingEvent({
        type: 'clear'
      });
      pushTargetingEvent(newTargeting);
    }
  };
  React.useEffect(function () {
    var _a;
    window.meso = (_a = window.meso) !== null && _a !== void 0 ? _a : {};
    advertising.includeAd();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React.useEffect(function () {
    processTargeting();
  }, [advertising, detailQuery, searchSummary === null || searchSummary === void 0 ? void 0 : searchSummary.resolvedRegion, searchCriteriaStore === null || searchCriteriaStore === void 0 ? void 0 : searchCriteriaStore.searchQuery, searchCriteriaStore === null || searchCriteriaStore === void 0 ? void 0 : searchCriteriaStore.localDateFormat]);
  return null;
};